// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_sec {
  max-width: 100%;
  width: 100%;
  display: block;
  padding: 0 1%;
}

.profile_sec {
  margin: 0;
  padding: 0;
  width: 100%;
}

.toggleclass::after {
  display: none !important;
}

li {
  list-style: none;
}

li,
a:after {
  content: none !important;
}

.profile_sec li {
  list-style: none;
  flex: 1;
}

li.nav-profile {
  position: relative !important;
}

.dropdown-menu.show {
  right: 0;
  left: auto;
}

.custom_sec .profile_sec .profile_drop img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  padding: 3px;
}

.custom_sec .profile_sec img {
  border-radius: 50%;
  padding: 3px;
}

.custom_sec .nav-link {
  display: flex;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  color: #383838;
  transition: color 0.2s ease-in-out;
  padding: 4px 5px;
}

.custom_sec .nav-link i {
  margin-right: 6px;
}

.justify {
  justify-content: flex-end;
}

@media only screen and (max-width: 575px) {
  .custom_sec {
    max-width: 100%;
    width: 100%;
    display: block;
    padding: 0 1%;
    margin: 2%;
  }
  .custom_sec li {
    margin: 10px 0px;
  }
  .form_drop {
    left: auto !important;
    right: 0 !important;
  }
  li.nav-profile {
    position: relative !important;
  }
}
@media only screen and (max-width: 480px) {
  .custom_mobile_sec {
    width: 80%;
  }
  ngx-select-dropdown {
    width: 160px;
  }
  .custom_mobile_sec .navbar-content {
    padding-left: 0;
  }
  .form_drop {
    left: 20% !important;
    right: auto !important;
  }
  li.nav-profile {
    position: static !important;
  }
}
@media only screen and (max-width: 400px) {
  .custom_mobile_sec {
    width: 76%;
  }
  ngx-select-dropdown {
    width: 160px;
  }
  .custom_mobile_sec .navbar-content {
    padding-left: 0;
  }
}
.indicator .circle::before,
.pulse {
  animation-name: pulse;
  animation-duration: 0.9s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-out;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .swal2-popup {
    width: 230px !important;
  }
}
.imgwid {
  max-width: 55%;
}

.pointer {
  text-align: end;
}

.nowrap {
  white-space: nowrap;
}

.usertext {
  align-self: center;
  padding: 0px 0px 0px 15px;
  text-align: right;
}

.padding_left {
  padding-left: 35px;
}

.userimage {
  align-self: center;
}

.todayDate {
  align-self: center;
  text-align: left;
}

.fontColor {
  color: black;
  font-weight: bold;
  font-size: 24px;
}

.fontColor1 {
  color: #1C2B47;
  font-size: 15px;
}

.formPadd {
  padding-top: 18px;
}

.mobileTitle {
  color: #1C2B47;
  position: absolute;
  left: 90px;
  top: 34% px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding-right: 42px;
}
@media only screen and (max-width: 750px) {
  .mobileTitle {
    font-size: 20px;
  }
}
@media only screen and (max-width: 560px) {
  .mobileTitle {
    font-size: 18px;
  }
}
@media only screen and (max-width: 428px) {
  .mobileTitle {
    font-size: 16px;
  }
}
@media only screen and (max-width: 360px) {
  .mobileTitle {
    font-size: 12px;
  }
}

.progressline {
  bottom: 0px;
  left: 0px;
  position: absolute;
  height: 2.6px;
  width: 100%;
  background: linear-gradient(#6CB449 0 0), linear-gradient(#2077A9 0 0), #e3effa;
  background-size: 60% 100%;
  background-repeat: no-repeat;
  animation: progress-7x9cg2 1.4s infinite;
}

@keyframes progress-7x9cg2 {
  0% {
    background-position: -150% 0, -150% 0;
  }
  66% {
    background-position: 250% 0, -150% 0;
  }
  100% {
    background-position: 250% 0, 250% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;EACA,WAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;;EAEI,wBAAA;AACJ;;AAOA;EACI,gBAAA;EACA,OAAA;AAJJ;;AAOA;EACI,6BAAA;AAJJ;;AAOA;EACI,QAAA;EACA,UAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,yBAAA;AAJJ;;AAOA;EACI;IACI,eAAA;IACA,WAAA;IACA,cAAA;IACA,aAAA;IACA,UAAA;EAJN;EAOE;IACI,gBAAA;EALN;EAQE;IACI,qBAAA;IACA,mBAAA;EANN;EASE;IACI,6BAAA;EAPN;AACF;AAWA;EACI;IACI,UAAA;EATN;EAYE;IACI,YAAA;EAVN;EAaE;IACI,eAAA;EAXN;EAcE;IACI,oBAAA;IACA,sBAAA;EAZN;EAeE;IACI,2BAAA;EAbN;AACF;AAiBA;EACI;IACI,UAAA;EAfN;EAkBE;IACI,YAAA;EAhBN;EAmBE;IACI,eAAA;EAjBN;AACF;AAqBA;;EAGI,qBAAA;EAEA,wBAAA;EAEA,mCAAA;EAEA,mCAAA;AAnBJ;;AAuBA;EAEI;IACI,uBAAA;EArBN;AACF;AAwBA;EAII,cAAA;AAzBJ;;AA4BA;EACI,eAAA;AAzBJ;;AA4BA;EACI,mBAAA;AAzBJ;;AA4BA;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;AAzBJ;;AA4BA;EACI,kBAAA;AAzBJ;;AA4BA;EACI,kBAAA;AAzBJ;;AA4BA;EACI,kBAAA;EACA,gBAAA;AAzBJ;;AA4BA;EACI,YAAA;EACA,iBAAA;EAEA,eAAA;AA1BJ;;AA6BA;EACI,cAAA;EACA,eAAA;AA1BJ;;AA6BA;EACI,iBAAA;AA1BJ;;AA6BA;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AA1BJ;AA4BI;EAVJ;IAYQ,eAAA;EA1BN;AACF;AA4BI;EAfJ;IAiBQ,eAAA;EA1BN;AACF;AAgCI;EAxBJ;IA0BQ,eAAA;EA9BN;AACF;AAgCI;EA7BJ;IA+BQ,eAAA;EA9BN;AACF;;AAiCA;EACI,WAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,+EAAA;EACA,yBAAA;EACA,4BAAA;EACA,wCAAA;AA9BJ;;AAiCA;EACI;IACI,qCAAA;EA9BN;EAiCE;IACI,oCAAA;EA/BN;EAkCE;IACI,mCAAA;EAhCN;AACF","sourcesContent":[".custom_sec {\n    max-width: 100%;\n    width: 100%;\n    display: block;\n    padding: 0 1%;\n}\n\n.profile_sec {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n}\n\n.toggleclass::after {\n    display: none !important;\n}\n\nli {\n    list-style: none;\n}\n\nli,\na:after {\n    content: none !important;\n}\n\n//  a::after\n//  {\n//      content: none;\n//  }\n\n.profile_sec li {\n    list-style: none;\n    flex: 1;\n}\n\nli.nav-profile {\n    position: relative !important;\n}\n\n.dropdown-menu.show {\n    right: 0;\n    left: auto;\n}\n\n.custom_sec .profile_sec .profile_drop img {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.custom_sec .profile_sec img {\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.custom_sec .nav-link {\n    display: flex;\n    align-items: center;\n    margin-left: 0;\n    margin-right: 0;\n    color: #383838;\n    transition: color .2s ease-in-out;\n    padding: 4px 5px;\n}\n\n.custom_sec .nav-link i {\n    margin-right: 6px;\n}\n\n.justify {\n    justify-content: flex-end;\n}\n\n@media only screen and (max-width:575px) {\n    .custom_sec {\n        max-width: 100%;\n        width: 100%;\n        display: block;\n        padding: 0 1%;\n        margin: 2%;\n    }\n\n    .custom_sec li {\n        margin: 10px 0px;\n    }\n\n    .form_drop {\n        left: auto !important;\n        right: 0 !important;\n    }\n\n    li.nav-profile {\n        position: relative !important;\n    }\n}\n\n\n@media only screen and (max-width:480px) {\n    .custom_mobile_sec {\n        width: 80%;\n    }\n\n    ngx-select-dropdown {\n        width: 160px;\n    }\n\n    .custom_mobile_sec .navbar-content {\n        padding-left: 0;\n    }\n\n    .form_drop {\n        left: 20% !important;\n        right: auto !important;\n    }\n\n    li.nav-profile {\n        position: static !important;\n    }\n\n}\n\n@media only screen and (max-width:400px) {\n    .custom_mobile_sec {\n        width: 76%;\n    }\n\n    ngx-select-dropdown {\n        width: 160px;\n    }\n\n    .custom_mobile_sec .navbar-content {\n        padding-left: 0;\n    }\n\n}\n\n.indicator .circle::before,\n.pulse {\n    -webkit-animation-name: pulse;\n    animation-name: pulse;\n    -webkit-animation-duration: .9s;\n    animation-duration: .9s;\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n}\n\n\n@media only screen and (min-width : 320px) and (max-width : 480px) {\n\n    .swal2-popup {\n        width: 230px !important;\n    }\n}\n\n.imgwid {\n    // width: 60px;\n    // width: 100%;\n    // max-width: 70%;\n    max-width: 55%;\n}\n\n.pointer {\n    text-align: end;\n}\n\n.nowrap {\n    white-space: nowrap;\n}\n\n.usertext {\n    align-self: center;\n    padding: 0px 0px 0px 15px;\n    text-align: right;\n}\n\n.padding_left {\n    padding-left: 35px;\n}\n\n.userimage {\n    align-self: center;\n}\n\n.todayDate {\n    align-self: center;\n    text-align: left;\n}\n\n.fontColor {\n    color: black;\n    font-weight: bold;\n    // font-size: 15px;\n    font-size: 24px;\n}\n\n.fontColor1 {\n    color: #1C2B47;\n    font-size: 15px;\n}\n\n.formPadd {\n    padding-top: 18px;\n}\n\n.mobileTitle {\n    color: #1C2B47;\n    position: absolute;\n    left: 90px;\n    top: 34%px;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    padding-right: 42px;\n\n    @media only screen and (max-width:750px) {\n        // top: 30%;\n        font-size: 20px;\n    }\n\n    @media only screen and (max-width:560px) {\n        // top: 12%;\n        font-size: 18px;\n    }\n\n    // @media only screen and (max-width:520px) {\n    //     top: 16%;\n    //     font-size: 18px;\n    // }\n    @media only screen and (max-width:428px) {\n        // top: 16%;\n        font-size: 16px;\n    }\n\n    @media only screen and (max-width:360px) {\n        // top: 15%;\n        font-size: 12px;\n    }\n}\n\n.progressline {\n    bottom: 0px;\n    left: 0px;\n    position: absolute;\n    height: 2.6px;\n    width: 100%;\n    background: linear-gradient(#6CB449 0 0), linear-gradient(#2077A9 0 0), #e3effa;\n    background-size: 60% 100%;\n    background-repeat: no-repeat;\n    animation: progress-7x9cg2 1.4s infinite;\n}\n\n@keyframes progress-7x9cg2 {\n    0% {\n        background-position: -150% 0, -150% 0;\n    }\n\n    66% {\n        background-position: 250% 0, -150% 0;\n    }\n\n    100% {\n        background-position: 250% 0, 250% 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
